// test738
(738 && 0);
